import React, { useEffect, useState } from 'react'
import { Card, Col, Form, Row } from 'react-bootstrap'
import { useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'

import { faSave, faRemove } from '@fortawesome/free-solid-svg-icons'

import BreadcrumbComponent from '@component/Breadcrumb'
import ButtonComponent from '@component/Form/Button'
import CpfComponent from '@component/Form/Cpf'
import DateComponent from '@component/Form/Date'
import InputComponent from '@component/Form/Input'
import SelectComponent from '@component/Form/Select'
import TextareaComponent from '@component/Form/Textarea'

import { AclService } from '@service/acl'
import { DepartmentService } from '@service/departments'
import { GenericService } from '@service/generic'
// import { OmbudsmanCategoryService } from '@service/ombudsman/categories'
import { OmbudsmanManifestationService } from '@service/ombudsman/manifestations'
import { OmbudsmanOriginService } from '@service/ombudsman/origins'
import { OmbudsmanTypeService } from '@service/ombudsman/types'

import Swal from 'sweetalert2'


const breadcrumbItems = [
    { title: 'Dashboard', url: '/dashboard' },
    { title: 'Lista de Ocorrências', url: '/ombudsman/manifestations' },
    { title: 'Nova Ocorrência' }
]


export default function ManifestationsCreate() {

    const navigate = useNavigate();

    const [anonymous, setAnonymous] = useState(false);

    const [typeOptions, setTypeOptions] = useState([]);
    const [originOptions, setOriginOptions] = useState([]);
    // const [categoryOptions, setCategoryOptions] = useState([]);
    const [departmentOptions, setDepartmentOptions] = useState([]);

    const { 
        control, 
        formState: { errors }, 
        handleSubmit, 
        register,
        setValue,
        reset
    } = useForm({ 
        mode: 'onChange',
        defaultValues: {
            date: new Date(),
            anonymous: false
        } 
    })


    const onSubmit = async (data, e) => {
        e.preventDefault();

        data.status = true;
        data.id_user = AclService.getUser().id;
        
        Swal.fire({
            allowEscapeKey: false,
            allowOutsideClick: false,
            closeOnClickOutside: false,
            closeOnEsc: false,
            imageUrl: '/assets/images/loading.gif',
            imageWidth: 100,
            imageHeight: 100,
            text: 'Processando, aguarde...',
            showConfirmButton: false,
            width: 300,
        });
        
        await OmbudsmanManifestationService.store(data)
            .then(response => {

                Swal.close();
                Swal.fire({
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    closeOnEsc: false,
                    html: response.data.message,
                    icon: 'success',
                }).then(() => navigate(`/ombudsman/manifestations/details/${response.data.ombudsman_manifestation_id}`));

            })
            .catch(error => { 
                Swal.close();
                Swal.fire({
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    closeOnEsc: false,
                    icon: 'error',
                    text: error.response.data.message
                });
            });
    }

    
    useEffect(() => {
        GenericService.selectOptions(OmbudsmanTypeService, setTypeOptions);
        GenericService.selectOptions(OmbudsmanOriginService, setOriginOptions);
        // GenericService.selectOptions(OmbudsmanCategoryService, setCategoryOptions);
        GenericService.selectOptions(DepartmentService, setDepartmentOptions);
    }, [])


    return (

        <>

            <div className='header' id='customer_form'>
                <h1 className='header-title'>Nova Ocorrência</h1>
                <BreadcrumbComponent breadcrumb={breadcrumbItems} />
            </div>


            <Form 
                autoComplete='off'
                id='form-manifestation-create'
                noValidate
                onSubmit={handleSubmit(onSubmit)}>
            
                <Row className='mb-3'>
                    <Col>
                        <Card>
                            <Card.Body>

                                <Row>
                                    <Col lg={2}>
                                        <DateComponent
                                            control={control}
                                            errors={errors}
                                            label='Data da Ocorrência'
                                            name='date'
                                            register={register}
                                            required={true}
                                        />
                                    </Col>

                                    <Col lg={2}>
                                        <SelectComponent
                                            control={control}
                                            errors={errors}
                                            label='Tipo de Manifestação'
                                            name='id_type'
                                            register={register}
                                            required={true}
                                            options={typeOptions}
                                        
                                        />
                                    </Col>

                                    <Col lg={2}>
                                        <SelectComponent
                                            control={control}
                                            errors={errors}
                                            label='Origem da Manifestação'
                                            name='id_origin'
                                            register={register}
                                            required={true}
                                            options={originOptions}
                                        />
                                    </Col>

                                    {/* <Col lg={3}>
                                        <SelectComponent
                                            control={control}
                                            errors={errors}
                                            label='Categoria'
                                            name='id_category'
                                            register={register}
                                            required={true}
                                            options={categoryOptions}
                                        />
                                    </Col> */}

                                    <Col lg={3}>
                                        <SelectComponent
                                            control={control}
                                            errors={errors}
                                            label='Departamento'
                                            name='id_departament'
                                            register={register}
                                            required={true}
                                            options={departmentOptions}
                                        />
                                    </Col>
                                </Row>

                            </Card.Body>
                        </Card>
                    </Col>
                </Row>


                <Row className='mb-3'>
                    <Col>
                        <Card>
                            <Card.Body>

                                <Row>
                                    <Col lg={4}>


                                        <Form.Group>
                                            <Form.Label htmlFor='anonymous'>Qual tipo de identificação deseja utilizar para manifestante?</Form.Label>
                                            <div class="btn-group btn-group-toggle mb-3" data-toggle="buttons">
                                                <label className={`btn btn-lg btn-primary ${anonymous === false ? 'active' : null}`}>
                                                    <input type="radio" name="radio_anonymous" autocomplete="off" onClick={(e) => setAnonymous(false)} value={false} checked style={{display:'none'}} /> Identificada
                                                </label>

                                                <label className={`btn btn-lg btn-primary ${anonymous === true ? 'active' : null}`}>
                                                    <input type="radio" name="radio_anonymous" autocomplete="off" onClick={(e) => setAnonymous(true)} value={true} style={{display:'none'}} /> Anônima
                                                </label>
                                            </div>
                                            <Form.Control control={control} errors={errors} type='hidden' name='anonymous' value={anonymous} register={register} />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <div className={anonymous === true ? 'd-none' : 'd-block'}>

                                    <Row className='mb-3'>
                                        <Col lg={2}>
                                            <CpfComponent
                                                control={control}
                                                errors={errors}
                                                label='CPF'
                                                name='cpf'
                                                required={anonymous === false ? true : false}
                                                disabled={anonymous === true ? true : false}
                                                type='text'
                                                register={register}
                                            />
                                        </Col>

                                        <Col lg={2}>
                                            <InputComponent
                                                control={control}
                                                errors={errors}
                                                label='Cartão SUS'
                                                name='card'
                                                placeholder='Informe o código do cartão SUS'
                                                required={false}
                                                type='text'
                                                register={register}
                                            />
                                        </Col>

                                        <Col lg={6}>
                                            <InputComponent
                                                control={control}
                                                errors={errors}
                                                label='Nome Completo'
                                                name='name'
                                                placeholder='Informe o nome completo'
                                                required={anonymous === false ? true : false}
                                                disabled={anonymous === true ? true : false}
                                                type='text'
                                                register={register}
                                            />
                                        </Col>

                                        <Col lg={2}>
                                            <DateComponent
                                                control={control}
                                                errors={errors}
                                                label='Data Nascimento'
                                                name='date_birth'
                                                required={anonymous === false ? true : false}
                                                disabled={anonymous === true ? true : false}
                                            />
                                        </Col>
                                    </Row>

                                    <Row className='mb-3'>
                                        <Col lg={3}>
                                            <InputComponent
                                                control={control}
                                                errors={errors}
                                                label='E-mail'
                                                name='email'
                                                placeholder='Informe o e-mail'
                                                required={false}
                                                disabled={anonymous === true ? true : false}
                                                type='text'
                                                register={register}
                                            />
                                        </Col>

                                        <Col lg={3}>
                                            <InputComponent
                                                control={control}
                                                errors={errors}
                                                label='Telefone/Celular'
                                                name='phone'
                                                placeholder='Informe o telefone'
                                                required={anonymous === false ? true : false}
                                                disabled={anonymous === true ? true : false}
                                                type='text'
                                                register={register}
                                            />
                                        </Col>
                                    </Row>

                                </div>

                            </Card.Body>
                        </Card>
                    </Col>
                </Row>


                <Row className='mb-3'>
                    <Col>
                        <Card>
                            <Card.Body>

                                <Row>
                                    <Col lg={12}>
                                        <h4>Ocorrência</h4>
                                    </Col>
                                </Row>
                                
                                <Row>
                                    <Col lg={12}>
                                        <TextareaComponent
                                            control={control}
                                            errors={errors}
                                            name='description'
                                            placeholder='Descriva o ocorrido'
                                            required={true}
                                            register={register}
                                            rows={4}
                                        />
                                    </Col>
                                </Row>

                            </Card.Body>
                        </Card>
                    </Col>
                </Row>


                <Row className='mb-3'>
                    <Col>
                        <Card>
                            <Card.Body>

                                <Row>
                                    <Col lg={6}>
                                        <ButtonComponent
                                            variant='danger'
                                            icon={faRemove}
                                            id='btn-cancel'
                                            title='Cancelar'
                                            type='button'
                                            onClick={() => navigate('/ombudsman/manifestations')}
                                        />
                                    </Col>

                                    <Col lg={6} className='text-end'>
                                        <ButtonComponent
                                            variant='success'
                                            icon={faSave}
                                            id='btn-save'
                                            title='Gravar'
                                        />
                                    </Col>
                                </Row>

                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            
            </Form>

        </>

    )
}
